











































































// Vue
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

// components
import { Select } from '@/components/form'
import { Loading } from '@/components'

@Component({
    name: 'DataTable',
    components: {
        Select,
        Loading
    }
})
export default class DataTable extends Vue {
    @Prop({ default: false, type: Boolean }) readonly striped!: boolean
    @Prop({ default: false, type: Boolean }) readonly hover!: boolean
    @Prop({ default: false, type: Boolean }) readonly loading!: boolean
    @Prop({ default: () => [], type: Array }) readonly items!: []
    @Prop({ required: true, type: Array }) readonly fields!: []
    @Prop({ type: Boolean, default: true }) readonly small!: boolean
    @Prop({ type: Boolean, default: true }) readonly bordered!: boolean
    @Prop({ type: Number, default: 0 }) readonly page!: number
    @Prop({ type: Number, default: 0 }) readonly pagesTotal!: number
    @Prop({ type: Number, default: 0 }) readonly totalRows!: number
    @Prop({ type: Number, default: 0 }) readonly perPage!: number
    @Prop({ type: String, default: '' }) readonly sortBy!: string
    @Prop({ type: String, default: '' }) readonly filter!: string
    @Prop({ type: Boolean, default: false }) readonly stickyHeader!: boolean

    currentPage = 1
    emptyText = 'No se han encontrado registros'
    optionsPerPage = [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 150, text: '150' },
        { value: 300, text: '300' },
        { value: 500, text: '500' },
        { value: 1000, text: '1000' }
    ]

    perPageSelected = 10

    created () {
        if (this.page > 0) {
            this.currentPage = this.page
        }
        this.perPageSelected = this.perPage
    }

    toCellName (slot: string) {
      return `cell(${slot})`
    }

    toHeadCellName (slot: string) {
      return `head(${slot})`
    }

    @Watch('page', { immediate: true, deep: true })
    changePage () {
        if (this.page > 0) {
            this.currentPage = this.page
        }
    }
}
